import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import TimeAdmin from "@/pages/TimeAdmin";
export const Route = createFileRoute("/time-admin")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><TimeAdmin /></ProtectedRoute>) });
